import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "customers list" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-warning text-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-1 mb-2" }, "No customers found", -1)
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = {
  key: 1,
  class: "table table-hover"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Company"),
  /*#__PURE__*/_createElementVNode("th", null, "Branch"),
  /*#__PURE__*/_createElementVNode("th", null, "AC Client Code"),
  /*#__PURE__*/_createElementVNode("th", null, "Nominal Code"),
  /*#__PURE__*/_createElementVNode("th", null, "Region"),
  /*#__PURE__*/_createElementVNode("th", { width: "7%" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Actions")
  ])
], -1)
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "text-right" }
const _hoisted_9 = { class: "list-unstyled mb-0" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]

import { computed, onMounted, inject } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { useToast } from "vue-toastification";
import { Customer, Office } from "@/models";
import { sortCustomerList } from "@/utilities";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomersList',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();
const toasted = useToast();

const actProperty: any = inject('actProperty');

const hasBlockingRequests = computed(() => store.getters['app/hasBlockingRequests']);
const customers = computed(() => store.getters['customers/list']);
const offices = computed(() => store.getters['offices/getOffices']);

const sortedcustomers = computed(() => sortCustomerList(customers.value));

const edit = (customer: Customer) => {
  if (customer.hasOwnProperty("id")) {
    router.push({ name: "customer", params: { id: customer.id } });
  } else {
    actProperty.displayError("Error");
  }
};

const remove = async (customer: Customer) => {
  actProperty
    .confirmPrompt()
    .then(() => deleteCustomer(customer))
    .then(() => toasted.success("Customer deleted"))
    .catch((err: any) => actProperty.displayError(err));
};
const deleteCustomer = async (customer: Customer) => {
  await store.dispatch('customers/deleteCustomer', customer);
};

const getRegion = (id: string): string => {
  let office = offices.value.find((o: Office) => o.id == id);
  return office ? office.name : "";
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!customers.value.length && !hasBlockingRequests.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode(" beginning with “"),
            _createElementVNode("strong", null, _toDisplayString((_unref(route).params.search as string).toUpperCase()), 1),
            _createTextVNode("” ")
          ])
        ]))
      : (_openBlock(), _createElementBlock("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedcustomers.value, (customer) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: customer.id,
                onClick: ($event: any) => (edit(customer))
              }, [
                _createElementVNode("td", null, _toDisplayString(customer.companyName), 1),
                _createElementVNode("td", null, _toDisplayString(customer.branchName), 1),
                _createElementVNode("td", null, _toDisplayString(customer.acClientCode), 1),
                _createElementVNode("td", null, _toDisplayString(customer.nominalCode), 1),
                _createElementVNode("td", null, _toDisplayString(getRegion(customer.office)), 1),
                _createElementVNode("td", _hoisted_8, [
                  _createElementVNode("ul", _hoisted_9, [
                    _createElementVNode("li", {
                      class: "list-item",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("button", {
                        class: "btn btn-outline-danger",
                        onClick: ($event: any) => (remove(customer))
                      }, _hoisted_12, 8, _hoisted_10)
                    ])
                  ])
                ])
              ], 8, _hoisted_7))
            }), 128))
          ])
        ]))
  ]))
}
}

})